import Backbone from "backbone";
import * as _ from "underscore";

import Shelf from "models/ShelfModel";

const ShelvesCollection = Backbone.Collection.extend({
  model: Shelf,
  url: "/api/shelves",
  initialize: function () {
    this._selectedShelfID = null; // null means no collection selected

    this.on("booksAdded", (shelf, booksAdded) => {
      if (shelf.id === "unshelved") {
        return;
      }

      if (this.unshelved) {
        this.unshelved.set(
          "books",
          _.chain(this.unshelved.get("books"))
            .pluck("bookID")
            .difference(booksAdded)
            .map((id) => ({
              bookID: id,
            }))
            .value()
        );
      }
    });
    this.on("booksRemoved", (shelf, booksRemoved) => {
      if (shelf.id === "unshelved") {
        return;
      }

      if (this.unshelved) {
        // check for each book in booksRemoved to see whether it's still on a shelf,
        // if not, add it to unshelved
        _.each(booksRemoved, (bookID) => {
          const onShelf = this.any((innerShelf) =>
            _.contains(_.pluck(innerShelf.get("books"), "bookID"), bookID)
          );

          if (!onShelf) {
            const unshelvedBooks = _.clone(this.unshelved.get("books"));
            unshelvedBooks.push({ bookID: bookID });
            this.unshelved.set("books", unshelvedBooks);
          }
        });
      }
    });

    this.on("add remove", (model) => {
      if (model.id === "unshelved") {
        this.unshelved = model;
      }
    });

    this.allBooksCount = 0;
  },
  reset: function (...args) {
    this.unshelved = undefined;
    Backbone.Collection.prototype.reset.apply(this, args as any);
  },
  getSelectedShelfID: function () {
    return this._selectedShelfID;
  },
  setSelectedShelfID: function (shelfID) {
    this._selectedShelfID = shelfID;
    this.trigger("change:shelfID", shelfID === "unshelved" ? null : shelfID);
  },
  shelvesContainingBooks: function (bookIDs) {
    return this.filter(
      (shelf) =>
        shelf.id !== "unshelved" &&
        _.any(shelf.get("books"), (book) => _.contains(bookIDs, book.bookID))
    );
  },
  addNewBook: function (bookID) {
    // check it's not in any existing shelves
    const shelves = this.shelvesContainingBooks([bookID]);

    if (shelves.length === 0) {
      this.unshelved.addBookID(bookID);
    }
  },
});

export default ShelvesCollection;
